import React from 'react';
import classNames from 'classnames';
import styles from './Slider.css';

type SliderProps = {
    children?: any;
    className?: string;
};

export class Slider extends React.PureComponent<SliderProps> {
    render() {
        const {children, className} = this.props;

        return (
            <div className = {classNames(styles['slider-container'], className)}>
                {children}
            </div>
        );
    }
}
